import { z } from "zod";

import { playablePrayerSchema } from "./playablePrayerSchema";

export const basePrayerInCollectionSchema = playablePrayerSchema.omit({
  images: true,
});

export const basePrayerInCollectionWithDateAvailableSchema =
  basePrayerInCollectionSchema.extend({
    date_available: z.iso.datetime().nullable(),
  });

export type BasePrayerInCollection = z.infer<
  typeof basePrayerInCollectionSchema
>;

export type BasePrayerInCollectionWithDateAvailable = z.infer<
  typeof basePrayerInCollectionWithDateAvailableSchema
>;
